import { configureLocalization } from "@lit/localize";
import { sourceLocale, targetLocales } from "./generated/locale-codes.js";
export const { getLocale, setLocale } = configureLocalization({
    sourceLocale,
    targetLocales,
    loadLocale: (locale) => {
        switch (locale) {
            case "en":
                return import(`./generated/locales/en.js`);
            case "de":
                return import(`./generated/locales/de.js`);
            case "es":
                return import(`./generated/locales/es.js`);
            case "fr":
                return import(`./generated/locales/fr.js`);
            case "it":
                return import(`./generated/locales/it.js`);
            case "ja":
                return import(`./generated/locales/ja.js`);
            case "nl":
                return import(`./generated/locales/nl.js`);
            case "pt":
                return import(`./generated/locales/pt.js`);
            case "zh":
                return import(`./generated/locales/zh.js`);
            default:
                throw new Error(`Couldn't load locales for "${locale}"`);
        }
    },
});
